import {
  Button,
  DatePicker,
  Form,
  PageHeader,
  Row,
  Select,
  Radio,
  Breadcrumb,
  Popconfirm,
  Col,
  Input,
  message,
  Spin,
  TimePicker,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import {
  companyService,
  vehicleService,
  stockClassificationService,
  receiptService,
  extraService,
} from "_services";

const Upload = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(false);
  const [isLoadingStores, setIsLoadingStores] = useState(false);
  const [isLoadingOwners, setIsLoadingOwners] = useState(false);
  const [isLoadingSupplierAddresses, setIsLoadingSupplierAddresses] =
    useState(false);
  const [isLoadingStoreAddresses, setIsLoadingStoreAddresses] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [deliveryFromAddresses, setDeliveryFromAddresses] = useState([]);
  const [selectedcustomer, setSelectedcustomer] = useState(null);
  const [stores, setStores] = useState([]);
  const [materialSuppliers, setMaterialSuppliers] = useState([]);
  const [isDetailedUpload, setIsDetailedUpload] = useState(Date());
  const [base64File, setBase64File] = useState(null);
  const [originalFileName, setOriginalFileName] = useState(null);
  const [stockClasses, setStockClasses] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState(null);

  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;

  useEffect(() => {
    getSupplierCompanies();
    getStoreCompanies();
    getOwnerCompanies();
    getStockClassifications();
    getVehicles();
  }, []);

  const getSupplierCompanies = () => {
    setIsLoadingSuppliers(true);
    companyService
      .getSuggestion("?companyTypeCodes=SUP,MSUP")
      .then((x) => {
        setIsLoadingSuppliers(false);
        setMaterialSuppliers(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingSuppliers(false);
        message.error(`${errorInfo}`);
      });
  };

  const getStoreCompanies = () => {
    setIsLoadingStores(true);
    companyService
      .getSuggestion("?companyTypeCodes=STORE")
      .then((x) => {
        setIsLoadingStores(false);
        setStores(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingStores(false);
        message.error(`${errorInfo}`);
      });
  };

  const getOwnerCompanies = () => {
    setIsLoadingOwners(true);
    companyService
      .getSuggestion("?companyTypeCodes=OWN")
      .then((x) => {
        setIsLoadingOwners(false);
        setcustomers(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingOwners(false);
        message.error(`${errorInfo}`);
      });
  };

  const getStockClassifications = () => {
    stockClassificationService
      .getMaterialSuggestion()
      .then((x) => {
        setStockClasses(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const getVehicles = () => {
    vehicleService
      .getSuggestion()
      .then((x) => {
        setVehicles(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const getSupplierAddresses = (companyId) => {
    if (companyId) {
      setDeliveryFromAddresses([]);
      form.resetFields(["deliveryFromAddress"]);
      setIsLoadingSupplierAddresses(true);
      companyService
        .getById(companyId)
        .then((x) => {
          setIsLoadingSupplierAddresses(false);
          setDeliveryFromAddresses(x.content.addresses);
        })
        .catch((errorInfo) => {
          setIsLoadingSupplierAddresses(false);
        });
    }
  };

  const getStoreAddresses = (companyId) => {
    if (companyId) {
      setStoreAddresses([]);
      form.resetFields(["storeAddress"]);
      setIsLoadingStoreAddresses(true);
      companyService
        .getById(companyId)
        .then((x) => {
          setIsLoadingStoreAddresses(false);
          setStoreAddresses(x.content.addresses);
        })
        .catch((errorInfo) => {
          setIsLoadingStoreAddresses(false);
        });
    }
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setError(null);
        setIsLoading(true);

        const payload = {
          customerId: values.customer.id,
          storeId: values.store.id,
          supplierId: values.materialSupplier.id,
          receivedDate: moment(values.receivedDate).format("YYYY-MM-DD"),
          invoiceDate: moment(values.receivedDate).format("YYYY-MM-DD"), //OrderDate
          deliverFrom: values.deliveryFromAddress.id,
          deliveryTo: values.storeAddress.id,
          supplierAddressId: values.deliveryFromAddress.id,
          base64FileString: base64File,
          originalFileName: originalFileName,
          remark: values.remark,
          receivingPerson: values.receivingPerson,
          packingStatus: "NEW",
          refNumber: values.refNumber,
          stockClassId: values.stockClassification.id,
          vehicleId: values.vehicle.id,
          driverName: values.driverName,
          driverContactNumber: values.driverContactNumber,
          containerNumber: values.containerNumber,
          tellerNumber: values.tellerNumber,
          sealNumber: values.sealNumber,
          inTime: moment(values.inTime).format("YYYY-MM-DD HH:mm:ss"),
          outTime: moment(values.outTime).format("YYYY-MM-DD HH:mm:ss"),
        };

        if (values.uploadOption === "SUMMARY") {
          receiptService
            .uploadSummaryReceipt(payload)
            .then(() => {
              message.success("Successfully uploaded!");
              setIsLoading(false);
              history.push(".");
            })
            .catch((error) => {
              setIsLoading(false);
              setError(error);
            });
        } else {
          extraService
            .uploadPackingList(payload)
            .then(() => {
              message.success("Successfully uploaded!");
              setIsLoading(false);
              history.push(".");
            })
            .catch((error) => {
              setIsLoading(false);
              setError(error);
            });
        }
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push("/stock-receipts");
  };

  const onFileChange = (e) => {
    if (e.target.files[0]) {
      setOriginalFileName(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function (e) {
        setBase64File(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipt Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Stock Receipt Upload</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Popconfirm
            title="Are you sure to add the changes?"
            onConfirm={handleFormSumbit}
            key="add-confirm"
          >
            <Button
              key="1"
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              Save
            </Button>
          </Popconfirm>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner error={error} onErrorDismissed={() => setError(null)}>
          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["materialSupplier", "id"]}
                    label="Supplier"
                    rules={[
                      { required: true, message: "Supplier is required" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      onChange={getSupplierAddresses}
                      loading={isLoadingSuppliers}
                    >
                      {materialSuppliers.length > 0 &&
                        materialSuppliers.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["store", "id"]}
                    label="Store"
                    rules={[{ required: true, message: "Store is required" }]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      onChange={getStoreAddresses}
                      loading={isLoadingStores}
                    >
                      {stores.length > 0 &&
                        stores.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name={["customer", "id"]} label="Customer">
                    <Select
                      showSearch
                      allowClear
                      showArrow={false}
                      optionFilterProp="children"
                      placeholder="Customer"
                      loading={isLoadingOwners}
                    >
                      {customers.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.name} ({t.code})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["stockClassification", "id"]}
                    label="Stock Category"
                    rules={[
                      { required: true, message: "Stock category is required" },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {stockClasses.length > 0 &&
                        stockClasses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["deliveryFromAddress", "id"]}
                    label="Deliver From"
                    rules={[
                      { required: true, message: "Delivery from is required" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      //disabled={isLoggedInCustomer()}
                      loading={isLoadingSupplierAddresses}
                    >
                      {deliveryFromAddresses.length > 0 &&
                        deliveryFromAddresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["storeAddress", "id"]}
                    label="Delivery To"
                    rules={[
                      {
                        required: true,
                        message: "Delivery address is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      loading={isLoadingStoreAddresses}
                    >
                      {storeAddresses.length > 0 &&
                        storeAddresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="receivedDate"
                    label="Received Date"
                    rules={[
                      { required: true, message: "Received date is required" },
                    ]}
                    initialValue={moment()}
                  >
                    <DatePicker
                      placeholder="Received date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="refNumber"
                    label="Ref. Number"
                    rules={[
                      {
                        required: true,
                        message: "Ref.Number is required.",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["vehicle", "id"]}
                    label="Vehicle"
                    rules={[{ required: true, message: "Vehicle is required" }]}
                  >
                    <Select
                      showSearch
                      allowClear
                      showArrow={false}
                      optionFilterProp="children"
                      placeholder="Vehicle"
                    >
                      {vehicles.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.number}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="inTime"
                    label="IN Time"
                    rules={[
                      {
                        required: false,
                        message: "Vehicle IN Time is required",
                      },
                    ]}
                  >
                    <TimePicker />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="outTime"
                    label="OUT Time"
                    rules={[
                      {
                        required: false,
                        message: "Vehicle OUT Time is required",
                      },
                    ]}
                  >
                    <TimePicker />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="receivingPerson"
                    label="Receiving Person"
                    rules={[
                      {
                        required: true,
                        message: "Receiving Person is required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item name="containerNumber" label="Container No:">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="tellerNumber" label="C. Trailer No:">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="sealNumber"
                    label="Seal No:"
                    rules={[
                      { required: true, message: "Seal No: is required" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="driverName"
                    label="Driver Name"
                    rules={[
                      { required: true, message: "Driver name is required" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item label="Upload Option" name="uploadOption">
                    <Radio.Group buttonStyle="solid" disabled>
                      <Radio.Button value="DETAILED">
                        Detailed Upload
                      </Radio.Button>
                      <Radio.Button value="SUMMARY">
                        Summary Upload
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="file"
                    label="Stock Receipt File"
                    rules={[
                      {
                        required: true,
                        message: "Valid excel file is required",
                      },
                    ]}
                    valuePropName="file"
                  >
                    <Input
                      type="file"
                      name="file"
                      onChange={onFileChange}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="remark" label="Remark">
                    <TextArea />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="driverContactNumber"
                    label="Driver Contact Number"
                    rules={[
                      {
                        required: true,
                        message: "river Contact Number is required",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
};

export default Upload;
